module.exports = __webpack_public_path__ + "static/media/ETH-WHT.6978721e.svg";